module.exports = __webpack_public_path__ + "img/Falkland Islands.0d361798.svg";